// // src/redux/slices/PayLoanEmiSlice.js
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// // ✅ Use env variable
// const BASE_URL = process.env.REACT_APP_API_URL;

// // 🔹 Pay EMI
// export const payLoanEmi = createAsyncThunk(
//   "loanEmi/payLoanEmi",
//   async ({ loanId, emiNumber, amountPaid, paymentMode, paymentDate }, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/loan/pay-emi?loanId=${loanId}`, // ✅ use BASE_URL
//         {
//           emiNumber,
//           amountPaid,
//           paymentMode,
//           paymentDate,
//         },
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || { message: err.message });
//     }
//   }
// );

// const payLoanEmiSlice = createSlice({
//   name: "payLoanEmi",
//   initialState: {
//     loading: false,
//     success: false,
//     message: null,
//     paidEMI: null,
//     unusedAmount: 0,
//     error: null,
//   },
//   reducers: {
//     resetPayLoanEmiState: (state) => {
//       state.loading = false;
//       state.success = false;
//       state.message = null;
//       state.paidEMI = null;
//       state.unusedAmount = 0;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(payLoanEmi.pending, (state) => {
//         state.loading = true;
//         state.success = false;
//         state.error = null;
//       })
//       .addCase(payLoanEmi.fulfilled, (state, action) => {
//         state.loading = false;
//         state.success = true;
//         state.message = action.payload.message;
//         state.paidEMI = action.payload.paidEMI;
//         state.unusedAmount = action.payload.unusedAmount || 0;
//         state.error = null;
//       })
//       .addCase(payLoanEmi.rejected, (state, action) => {
//         state.loading = false;
//         state.success = false;
//         state.error = action.payload?.message || "Payment failed.";
//       });
//   },
// });

// export const { resetPayLoanEmiState } = payLoanEmiSlice.actions;
// export default payLoanEmiSlice.reducer;



// src/redux/slices/PayLoanEmiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

/* ============================================================
   1️⃣ OLD API → FULL EMI
   ============================================================ */
export const payLoanEmi = createAsyncThunk(
  "loanEmi/payLoanEmi",
  async ({ loanId, emiNumber, amountPaid, paymentMode, paymentDate }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        // `${BASE_URL}/loan/pay-emi?loanId=${loanId}`,
        `${BASE_URL}/loan/pay-emi/withpanalty?loanId=${loanId}&emiNumber=${emiNumber}`,
        { emiNumber, amountPaid, paymentMode, paymentDate },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("paid",response)
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

/* ============================================================
   2️⃣ NEW API → PARTIAL + ADVANCE EMI
   ============================================================ */
export const payLoanEmiNew = createAsyncThunk(
  "loanEmi/payLoanEmiNew",
  async ({ loanId, emiNumber, amountPaid, paymentMode, paymentDate, paymentType }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/loan/pay-emi-new?loanId=${loanId}&emiNumber=${emiNumber}&paymentType=${paymentType}`,
        {
          amountPaid,
          paymentMode,
          paymentDate,
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);


const payLoanEmiSlice = createSlice({
  name: "payLoanEmi",
  initialState: {
    loading: false,
    success: false,
    message: null,
    paidEMI: null,
    unusedAmount: 0,
    error: null,
  },
  reducers: {
    resetPayLoanEmiState: (state) => {
      state.loading = false;
      state.success = false;
      state.message = null;
      state.paidEMI = null;
      state.unusedAmount = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    
    /* ------------------------
       OLD API → FULL PAYMENT
       ------------------------ */
    builder
      .addCase(payLoanEmi.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(payLoanEmi.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.paidEMI = action.payload.paidEMI;
        state.unusedAmount = action.payload.unusedAmount || 0;
      })
      .addCase(payLoanEmi.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "Payment failed.";
      });

    /* -----------------------------------------
       NEW API → PARTIAL + ADVANCE PAYMENT
       ----------------------------------------- */
    builder
      .addCase(payLoanEmiNew.pending, (state) => {
        state.loading = true;
      })
      .addCase(payLoanEmiNew.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.paidEMI = action.payload.paidEMI;
        state.unusedAmount = action.payload.unusedAmount || 0;
      })
      .addCase(payLoanEmiNew.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "Payment failed.";
      });
  },
});

export const { resetPayLoanEmiState } = payLoanEmiSlice.actions;
export default payLoanEmiSlice.reducer;

